import React from 'react';
import CartButtons from "./CartButtons";
import CartItemVehicle from "../../ShoppingCart/components/cart_contents/CartItemVehicle";
import {useThemeVar} from "../../Utility/siteConfig";
import LocalUrlMaker from "../../lib/LocalUrlMaker";
import CatchErrors from "../../Utility/CatchErrors";

export default function NewItemDetails({
  item, handleClose, shoppingCart,
  customerVehicle, ...props
}) {

  let price = new Money(item.effectiveUnitPrice || 0);

  let freeShipping = useThemeVar("freeShipping", false);

  if (!item) {
    return <CartButtons
      handleClose={handleClose}
      cartCode={shoppingCart.cartCode}
    />
  }

  return (
    <div className="text-pencil text-center lg:text-left">

      <div className="text-lg">
        {item.brandName} {item.name}</div>

      <div className="text-gray-400 text-lg">
        {price.toString()}
      </div>

      {freeShipping && <div className="text-brand-orange">Free Shipping</div>}

      <CartButtons handleClose={handleClose} cartCode={shoppingCart.cartCode}/>

      <CatchErrors label="new-item-vehicle">
        <CartItemVehicle item={item} quiet={true}/>

        <VehicleLink vehicle={customerVehicle}/>
      </CatchErrors>
    </div>
  );
}

// Show a "Shop more Ford F150 accessories" link.
// vehicleUrl may be missing as we don't have pages for obscure vehicles
function VehicleLink({vehicle}) {
  if (!vehicle || !vehicle.vehicleUrl)
    return null;

  return <div className="text-sm">
    <a className="!text-gray-400 underline p-2"
      href={LocalUrlMaker.prefixedPath(vehicle.vehicleUrl)}>
      Shop more {' '}
      {vehicle.shortMakeName || vehicle.vehicleMakeName} {' '}
      {vehicle.shortModelName || vehicle.vehicleModelName}
      {' '}
      accessories</a>
  </div>
}
